/* You Will Rock — product page behaviour. Prices, variant ids and the free-shipping
   threshold are rendered into data attributes by Liquid; nothing is retyped here. */
(function () {
  if (window.__ywrLoaded) return; window.__ywrLoaded = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = n => { const sym = ((document.querySelector('.ywr[data-currency]') || document.body).dataset.currency || '$'); return sym + (Math.abs(n - Math.round(n)) < 0.005 ? String(Math.round(n)) : n.toFixed(2)); };

  /* language dropdown (visual until localization is enabled) */
  const langDd = $('.lang-dd');
  if (langDd) {
    const langBtn = $('.lang-dd-btn', langDd);
    const closeLang = () => { langDd.classList.remove('open'); langBtn.setAttribute('aria-expanded', 'false'); };
    langBtn.addEventListener('click', e => { e.stopPropagation(); const o = !langDd.classList.contains('open'); langDd.classList.toggle('open', o); langBtn.setAttribute('aria-expanded', String(o)); });
    $$('li', langDd).forEach(li => li.addEventListener('click', () => { $$('li', langDd).forEach(x => x.classList.remove('on')); li.classList.add('on'); $('.lang-dd-val', langDd).textContent = li.dataset.label; closeLang(); if (li.dataset.href) location.href = li.dataset.href; }));
    document.addEventListener('click', e => { if (!e.target.closest('.lang-dd')) closeLang(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLang(); });
  }

  /* accordions (buy box + faq) */
  $$('[data-acc] .q').forEach(q => q.addEventListener('click', () => q.parentElement.classList.toggle('open')));

  /* timeline rails draw in on view */
  const tl = $('#tl');
  if (tl && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
    new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { tl.classList.add('in'); o.disconnect(); } }), { threshold: .3 }).observe(tl);
  } else if (tl) tl.classList.add('in');

  /* ---- library: trace one hand-drawn dashed run through the numbered dots ----
     Drawn rather than bordered, so it can curve, wrap and stay thick at any width. */
  const libGrid = $('.lib-grid');
  if (libGrid) {
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'lib-path'); svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('preserveAspectRatio', 'none');
    const path = document.createElementNS(NS, 'path');
    svg.appendChild(path); libGrid.prepend(svg);

    function traceLibrary() {
      const gb = libGrid.getBoundingClientRect();
      const books = $$('.lib-book', libGrid);
      const pts = $$('.lib-node', libGrid).map((n, i) => {
        const r = n.getBoundingClientRect(), c = books[i].getBoundingClientRect();
        return { x: r.left - gb.left + r.width / 2, y: r.top - gb.top + r.height / 2,
                 top: c.top - gb.top, bottom: c.bottom - gb.top };
      });
      if (pts.length < 2 || !gb.width) { svg.style.display = 'none'; return; }
      svg.style.display = '';
      svg.setAttribute('viewBox', '0 0 ' + gb.width + ' ' + gb.height);
      let d = 'M' + pts[0].x + ',' + pts[0].y;
      for (let i = 0; i < pts.length - 1; i++) {
        const a = pts[i], b = pts[i + 1];
        const dx = b.x - a.x, dy = b.y - a.y;
        if (Math.abs(dx) < 8) {
          /* stacked on mobile: waver left and right on the way down */
          const bow = (i % 2 ? -1 : 1) * 14;
          d += ' Q' + (a.x + bow) + ',' + (a.y + dy / 2) + ' ' + b.x + ',' + b.y;
        } else if (dx > 0) {
          /* the zigzag: a smooth crest or trough between one book and the next */
          d += ' C' + (a.x + dx * 0.45) + ',' + a.y
             + ' ' + (b.x - dx * 0.45) + ',' + b.y
             + ' ' + b.x + ',' + b.y;
        } else {
          /* falling back to a new row: out past the right edge and around */
          const xOut = gb.width + 18, lane = (a.bottom + b.top) / 2;
          d += ' C' + (a.x + 170) + ',' + a.y + ' ' + xOut + ',' + (a.y + 36) + ' ' + xOut + ',' + lane;
          d += ' C' + xOut + ',' + (lane + 30) + ' ' + (b.x + 210) + ',' + (lane + 8) + ' ' + b.x + ',' + b.y;
        }
      }
      path.setAttribute('d', d);
    }
    traceLibrary();
    addEventListener('resize', traceLibrary);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(traceLibrary);
    $$('.lib-art img', libGrid).forEach(im => { if (!im.complete) im.addEventListener('load', traceLibrary); });
  }

  /* ---- buy box ---- */
  const bb = $('[data-ywr-buybox]');
  if (bb) {
    const thumbs = $$('.thumbs .t', bb);
    const heroArts = $$('.hero-art', bb), heroImg = $('#hero-img'), badge = $('.badge', bb), thumbArt = $('#thumb-art');
    const opts = $$('.opt', bb);
    /* the selected rung's art fills the hero, thumbnail 1 and (later) the drawer */
    function showArt(i) {
      heroArts.forEach(a => { a.hidden = +a.dataset.rung !== i; });
      if (thumbArt && heroArts[i]) thumbArt.innerHTML = heroArts[i].innerHTML;
    }
    function showSlide(ti) {
      const t = thumbs[ti]; if (!t) return;
      thumbs.forEach(x => x.classList.toggle('on', x === t));
      if (badge) badge.hidden = ti !== 0;
      const artSlide = ti === 0 && heroArts.length > 0;
      heroArts.forEach(a => { if (!artSlide) a.hidden = true; });
      if (artSlide) showArt(opts.indexOf(selected()));
      const real = !!t.dataset.img;
      heroImg.hidden = artSlide || !real;
      if (real) { heroImg.src = t.dataset.img; heroImg.alt = t.getAttribute('aria-label') || ''; }
      if (typeof syncHero === 'function') syncHero();
    }
    thumbs.forEach((t, ti) => t.addEventListener('click', () => showSlide(ti)));

    /* arrows over the hero step through the same slides (and are the tap zones on mobile) */
    const hprev = $('.hnav.p', bb), hnext = $('.hnav.n', bb);
    if (hprev && hnext) {
      const at = () => Math.max(0, thumbs.findIndex(t => t.classList.contains('on')));
      const step = d => { const i = at() + d; if (i < 0 || i >= thumbs.length) return; showSlide(i); thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); };
      hprev.addEventListener('click', () => step(-1));
      hnext.addEventListener('click', () => step(1));
      var syncHero = () => { const i = at(); hprev.disabled = i <= 0; hnext.disabled = i >= thumbs.length - 1; };
      if (thumbs.length < 2) { hprev.hidden = true; hnext.hidden = true; }
    }

    /* the rail just scrolls; the hero arrows step through every image, so it needs no controls */
    const rail = $('.thumbs .trail', bb);
    if (rail && thumbs.length < 2) rail.parentElement.hidden = true;

    const addons = $$('.addon input[data-variant]', bb);
    const ebookRow = $('.addon[data-kind="ebooks"]', bb), ebookCb = ebookRow ? ebookRow.querySelector('input') : null;
    const shipbar = $('#shipbar'), shipH = $('#ship-h'), shipS = $('#ship-s'), shipFill = $('#ship-fill');
    const FREE_SHIP = +(shipbar ? shipbar.dataset.threshold : 0) || 0;
    const giftToggle = $('#gift-toggle'), gift = $('#gift'), wrapCb = $('#gift-wrap'), noteCb = $('#gift-note'), noteWrap = $('#note-wrap');
    const atcNote = $('#atc-note', bb);
    const price = el => +el.dataset.price || 0;

    function selected() { return opts.find(x => x.classList.contains('on')) || opts[0]; }
    /* rungs that carry the eBook set: the row reads Included, costs nothing, can't be unticked */
    function syncEbooks(o) {
      if (!ebookRow) return;
      const inc = o.dataset.ebooks === 'true';
      ebookRow.classList.toggle('included', inc);
      ebookCb.disabled = inc;
      ebookCb.checked = inc ? true : ebookCb.dataset.was !== '0';
      ebookRow.querySelector('em').textContent = inc ? 'Included' : ebookRow.querySelector('em').dataset.priceLabel;
      ebookRow.querySelectorAll('.tx [data-out]').forEach(el => {
        const alt = el.dataset.inc;
        el.textContent = inc && alt ? alt : el.dataset.out;
      });
    }
    function selectOpt(o) {
      opts.forEach(x => x.classList.toggle('on', x === o));
      const p = price(o), v = +o.dataset.value || 0;
      const pr = $('#prc', bb); if (pr) pr.textContent = money(p);
      const c = $('#cmp', bb); if (c) { c.textContent = v > p ? money(v) : ''; c.style.display = v > p ? '' : 'none'; }
      const sv = $('#save', bb); if (sv) { sv.textContent = o.dataset.note || ''; sv.style.display = o.dataset.note ? '' : 'none'; }
      const sn = $('#sel-name', bb); if (sn) sn.textContent = o.dataset.name || '';
      if (atcNote) atcNote.hidden = true;
      syncEbooks(o);
      syncSub(o);
      showSlide(0);
      recalc();
    }
    opts.forEach(o => o.addEventListener('click', () => selectOpt(o)));

    /* the promise under the title follows the picked rung, and who it is for */
    const sub = $('#bb-sub', bb), intentBtns = $$('[data-intent-group] .ib', bb);
    let intent = 'self';
    function syncSub(o) {
      if (!sub || !o) return;
      const alt = intent === 'gift' ? o.dataset.subheadGift : intent === 'partner' ? o.dataset.subheadPartner : '';
      sub.innerHTML = alt || o.dataset.subhead || sub.dataset.base || '';
    }
    intentBtns.forEach(b => b.addEventListener('click', () => {
      intent = b.dataset.intent;
      intentBtns.forEach(x => x.classList.toggle('on', x === b));
      syncSub(selected());
    }));
    addons.forEach(cb => cb.addEventListener('change', () => { if (!cb.disabled) cb.dataset.was = cb.checked ? '1' : '0'; recalc(); }));
    const moreBtn = $('#ladder-more', bb), quiet = $('#ladder-quiet', bb);
    if (moreBtn && quiet) moreBtn.addEventListener('click', () => {
      const open = moreBtn.getAttribute('aria-expanded') !== 'true';
      moreBtn.setAttribute('aria-expanded', String(open));
      quiet.classList.toggle('open', open);
    });
    if (giftToggle) giftToggle.addEventListener('click', () => { const open = !gift.classList.contains('open'); gift.classList.toggle('open', open); giftToggle.classList.toggle('open', open); });
    if (wrapCb) wrapCb.addEventListener('change', recalc);
    if (noteCb) noteCb.addEventListener('change', () => { noteWrap.classList.toggle('open', noteCb.checked); recalc(); });

    function recalc() {
      const o = selected(), p = price(o), premium = o.dataset.premium === 'true';
      let total = p;
      addons.forEach(cb => { cb.closest('.addon').classList.toggle('on', cb.checked); if (cb.checked && !cb.disabled) total += price(cb); });
      if (wrapCb && wrapCb.checked) total += price(wrapCb);
      const noteFree = premium && noteCb && noteCb.dataset.freeOnPremium === 'true';
      if (noteCb) { $('#note-price').textContent = noteFree ? 'Complimentary' : '+' + money(price(noteCb)); if (noteCb.checked && !noteFree) total += price(noteCb); }
      $('#atc-price', bb).textContent = money(total); $('#atc-cta', bb).textContent = o.dataset.cta || 'Add to cart';
      if (shipbar && FREE_SHIP) {
        const free = total >= FREE_SHIP - 0.001, gap = FREE_SHIP - total;
        shipbar.classList.toggle('on', free);
        shipH.textContent = 'Free US shipping on $90+; calculated below $90';
        shipS.textContent = free ? 'Your order is ' + money(total) + ' · shipping calculated below $90; free US shipping on $90+' : 'Add ' + money(gap) + ' more to unlock it';
        shipFill.style.setProperty('--p', Math.min(1, total / FREE_SHIP).toFixed(3));
        const st = $('#ship-text', bb); if (st) st.textContent = free ? (st.dataset.tail || '') : 'Standard shipping calculated below $90; free US shipping on $90+ · ' + (st.dataset.tail || '');
      }
    }

    /* Add to cart: the set variant + every checked add-on, one request.
       A mock rung (no product yet) explains itself instead of failing. */
    const atc = $('.atc', bb);
    atc.addEventListener('click', async () => {
      if (atc.disabled || window.YWRCartDrawer?.isBusy?.()) return;
      const o = selected(); const items = [];
      if (o.dataset.mock === '1') { if (atcNote) { atcNote.textContent = 'Preview: this set becomes purchasable at launch, once its product exists.'; atcNote.hidden = false; } return; }
      if (o.dataset.variant) items.push({ id: +o.dataset.variant, quantity: 1 });
      addons.forEach(cb => { if (cb.checked && !cb.disabled && cb.dataset.variant) items.push({ id: +cb.dataset.variant, quantity: 1 }); });
      if (wrapCb && wrapCb.checked && wrapCb.dataset.variant) items.push({ id: +wrapCb.dataset.variant, quantity: 1 });
      if (noteCb && noteCb.checked && noteCb.dataset.variant) items.push({ id: +noteCb.dataset.variant, quantity: 1, properties: { 'Gift note': ($('#note-text') || {}).value || '' } });
      if (!items.length) return;
      atc.disabled = true; const label = atc.innerHTML; atc.textContent = 'Adding…';
      try {
        const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error((await r.json()).description || 'Could not add to cart');
        if (typeof window.YWRCartDrawer?.afterAdd === 'function') {
          await window.YWRCartDrawer.afterAdd({trigger:atc,offerKey:o.dataset.variant});
          atc.disabled = false; atc.innerHTML = label;
          return;
        }
        location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      } catch (err) { atc.disabled = false; atc.innerHTML = label; if (atcNote) { atcNote.textContent = err.message; atcNote.hidden = false; } }
    });

    selectOpt(opts.find(x => x.classList.contains('on')) || opts[0]);

    /* anything on the page can pick a rung: the library strip's button, for one */
    $$('[data-select-rung]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); const o = opts[+b.dataset.selectRung]; if (!o) return; selectOpt(o); bb.scrollIntoView({ behavior: 'smooth', block: 'start' }); }));

    /* ---- help-me-decide drawer: two answers -> one recommendation, read off the ladder ---- */
    const hd = $('#hd'), hdOv = $('#hd-ov');
    if (hd) {
      const openHd = () => { hd.classList.add('open'); hdOv.classList.add('open'); document.body.style.overflow = 'hidden'; };
      const closeHd = () => { hd.classList.remove('open'); hdOv.classList.remove('open'); document.body.style.overflow = ''; };
      $$('[data-open-hd]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); openHd(); }));
      $('#hd-close').addEventListener('click', closeHd); hdOv.addEventListener('click', closeHd);
      document.addEventListener('keydown', e => { if (e.key === 'Escape') closeHd(); });
      const hdRes = $('#hd-res'), hdArt = $('#hd-art'), hdAlts = $$('.hd-alt'), hdChips = $$('.hd-chip');
      const answer = { far: 0, who: 'self' };
      let PICK = {}; try { PICK = JSON.parse(hd.dataset.pick || '{}'); } catch (e) { PICK = {}; }
      function fill(i, why, animate) {
        const o = opts[i]; if (!o) return;
        const p = price(o), v = +o.dataset.value || 0;
        $('#hd-name').textContent = $('.nm', o).textContent; $('#hd-inc').textContent = $('.inc', o).textContent;
        $('#hd-price').textContent = money(p); $('#hd-was').textContent = v > p ? money(v) : ''; $('#hd-save').textContent = o.dataset.note || '';
        $('#hd-why').textContent = why; if (hdArt && heroArts[i]) hdArt.innerHTML = heroArts[i].innerHTML;
        hdAlts.forEach(a => a.classList.toggle('on', +a.dataset.opt === i));
        $('#hd-atc').textContent = (o.dataset.cta || 'Add To Cart') + ' — ' + money(p); hdRes.dataset.opt = String(i);
        if (animate) { hdRes.classList.remove('settle'); void hdRes.offsetWidth; hdRes.classList.add('settle'); }
      }
      function render(animate) { const pick = (PICK[answer.who] || [])[answer.far]; if (pick) fill(pick.opt, pick.why, animate); }
      hdChips.forEach(c => c.addEventListener('click', () => { const g = c.closest('[data-q]'), q = g.dataset.q; $$('.hd-chip', g).forEach(x => x.setAttribute('aria-checked', String(x === c))); answer[q] = q === 'far' ? +c.dataset.v : c.dataset.v; render(true); }));
      $$('.hd-opts[role="radiogroup"]').forEach(g => g.addEventListener('keydown', e => { if (!/^Arrow(Left|Right|Up|Down)$/.test(e.key)) return; e.preventDefault(); const items = $$('.hd-chip', g), i = items.indexOf(document.activeElement), d = /Left|Up/.test(e.key) ? -1 : 1, n = items[(i + d + items.length) % items.length]; n.focus(); n.click(); }));
      const hdMore = $('#hd-more'), hdAltsBox = $('#hd-alts');
      hdMore.addEventListener('click', () => { const open = hdMore.getAttribute('aria-expanded') !== 'true'; hdMore.setAttribute('aria-expanded', String(open)); hdAltsBox.classList.toggle('open', open); });
      hdAlts.forEach(a => a.addEventListener('click', () => { const i = +a.dataset.opt; fill(i, 'Your pick. ' + ($('.cp', opts[i]) || {}).textContent, true); }));
      $$('[data-alt-price]').forEach((el, i) => { if (opts[i]) el.textContent = money(price(opts[i])); });
      render(false);
      $('#hd-atc').addEventListener('click', () => { selectOpt(opts[+hdRes.dataset.opt]); closeHd(); bb.scrollIntoView({ behavior: 'smooth' }); });
    }
  }

  /* ---- UGC ring ---- */
  const ring = $('#ugc-ring');
  if (ring) {
    const cards = $$('.card', ring), N = cards.length, dots = $$('.ugc .dots button');
    let a = 0, muted = true;
    const vid = c => c.querySelector('video');
    function layout() { cards.forEach((c, i) => { const d = ((i - a) % N + N + 4) % N - 4; c.dataset.d = d; c.setAttribute('aria-current', d === 0 ? 'true' : 'false'); }); dots.forEach((d, i) => d.classList.toggle('on', i === a)); }
    function stop(c) { const v = vid(c); if (v) v.pause(); c.classList.remove('playing'); }
    function play(c) { const v = vid(c); c.classList.add('playing'); c.classList.toggle('muted', muted); if (v) { v.muted = muted; v.play().catch(() => {}); } }
    function go(i) { const n = (i % N + N) % N; if (n === a) return; stop(cards[a]); a = n; layout(); play(cards[a]); }
    cards.forEach((c, i) => {
      c.addEventListener('click', e => { if (e.target.closest('.mute')) return; if (i !== a) { go(i); return; } c.classList.contains('playing') ? stop(c) : play(c); });
      c.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.click(); } });
      const m = c.querySelector('.mute'); if (m) m.addEventListener('click', () => { muted = !muted; c.classList.toggle('muted', muted); const v = vid(c); if (v) v.muted = muted; });
      const v = vid(c); if (v) { v.addEventListener('loadeddata', () => c.classList.add('live')); v.addEventListener('ended', () => go(a + 1)); }
    });
    const l = $('.arrow.l', ring), r = $('.arrow.r', ring); if (l) l.addEventListener('click', () => go(a - 1)); if (r) r.addEventListener('click', () => go(a + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    const stage = $('.stage', ring); let tx0 = null;
    stage.addEventListener('touchstart', e => { tx0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', e => { if (tx0 === null) return; const dx = e.changedTouches[0].clientX - tx0; tx0 = null; if (Math.abs(dx) > 40) go(dx < 0 ? a + 1 : a - 1); }, { passive: true });
    ring.addEventListener('keydown', e => { if (e.key === 'ArrowRight') go(a + 1); else if (e.key === 'ArrowLeft') go(a - 1); });
    layout(); play(cards[0]);
  }
})();
